// One observer reveals media once, including images added by filters or the editor.
(function () {
  'use strict';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var watched = new WeakSet();
  var observer = !reducedMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { rootMargin: '100px 0px', threshold: 0 })
    : null;

  function reveal(image) {
    image.classList.add('visible');
    if (observer) observer.unobserve(image);
  }

  function watch(image) {
    if (watched.has(image)) return;
    watched.add(image);
    if (!observer || image.classList.contains('visible') || image.getAttribute('fetchpriority') === 'high') {
      reveal(image);
    } else {
      observer.observe(image);
    }
  }

  function visit(root, callback) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches('img')) callback(root);
    root.querySelectorAll('img').forEach(callback);
  }

  visit(document.documentElement, watch);
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.removedNodes.forEach(function (node) {
          if (observer) visit(node, function (image) { observer.unobserve(image); });
        });
        record.addedNodes.forEach(function (node) {
          visit(node, function (image) {
            // A detached image can be inserted again by the theme editor.
            watched.delete(image);
            watch(image);
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function revealSlider(target) {
    var component = target.closest('slider-component, slideshow-component');
    if (component) component.querySelectorAll('.slider img').forEach(reveal);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.slider-button--next, .slider-button--prev')) revealSlider(event.target);
  });
  var touchStartX = null;
  document.addEventListener('touchstart', function (event) {
    touchStartX = event.touches.length ? event.touches[0].clientX : null;
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (touchStartX !== null && event.changedTouches.length && Math.abs(event.changedTouches[0].clientX - touchStartX) > 50) {
      revealSlider(event.target);
    }
    touchStartX = null;
  }, { passive: true });
})();
